import { useState } from 'react';
import './RecentAppointments.scss';
import {
  apiValidation,
  get,
  iosRedirect,
  isIosApp,
  isWebView,
  post,
  toastError,
  updateUsageTrack,
} from '../../Utilities';
import Swal from 'sweetalert2';
import { Drawer } from '@material-ui/core';

const AppointmentCard = ({
  appointment,
  isCompleted,
  clientId,
  clientUserId,
  userProfile,
  isDash,
  history,
}) => {
  const [isLoadingZoho, setIsLoadingZoho] = useState(false);
  const [checkLiveClass, setCheckLiveClass] = useState(false);
  const [drawer, setDrawer] = useState(false);

  const openDrawer = () => setDrawer(true);
  const handleCloseDrawer = () => setDrawer(false);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const formatTime = (timeString) => {
    const [hours, minutes] = timeString.split(':');
    const hour = parseInt(hours);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const displayHour = hour % 12 || 12;
    return `${displayHour}:${minutes} ${ampm}`;
  };

  const shouldShowJoinButton = (appointment) => {
    const now = new Date();
    const appointmentDateTime = new Date(
      `${appointment.appointment_date} ${appointment.start_time}`,
    );
    const tenMinutesBefore = new Date(appointmentDateTime.getTime() - 10 * 60 * 1000);

    return now >= tenMinutesBefore;
  };

  const startOrJoinClass = (appointment) => {
    if (appointment.host_id == clientUserId) {
      if (appointment.start_link) {
        if (isWebView) {
          window.location.href = element.start_link;
        } else if (isIosApp) {
          iosRedirect(element.start_link);
        } else {
          window.open(element.start_link, '_blank');
        }
        updateUsageTrack(clientId);
      } else {
        setIsLoadingZoho(true);

        const payload = {
          topic: appointment.appointment_title,
          appointment_order_id: appointment.appointment_order_id,
          client_user_id: clientUserId,
          client_id: clientId,
          name: appointment.host_name,
          contact: `${userProfile.contact}`,
          batch_array: JSON.stringify([]),
          user_array: JSON.stringify([appointment.client_user_id]),
          duration: 3600,
        };

        post(payload, '/startInstantMeetingZ').then((res) => {
          if (res && res.success) {
            if (isIosApp) {
              iosRedirect(res.result.startLink);
            } else {
              window.open(res.result.startLink, '_blank');
            }
          } else {
            toastError('Failed to start live class. Please contant your admin');
          }
          setIsLoadingZoho(false);
        });
      }
    } else {
      checkLiveStreamAndJoin(appointment);
    }
  };

  const checkLiveStreamAndJoin = (elem) => {
    const payload = {
      appointment_order_id: elem.appointment_order_id,
      client_user_id: clientUserId,
      client_id: clientId,
    };
    setCheckLiveClass(true);
    get(payload, '/getAppointmentLiveStatus').then((res) => {
      setCheckLiveClass(false);
      if (res && res.success) {
        const result = apiValidation(res);

        if (result.status === 'deleted') {
          Swal.fire({
            html: `<p style='font-size: 18px; margin-bottom: 0px'><b>This appointment has ended.</b></p>`,
          });
        } else if (result.status === 'active') {
          startLiveStream(result);
        } else if (result.status === 'pending') {
          Swal.fire({
            html: `<p style='font-size: 18px; margin-bottom: 0px'><b>Appointment has not started yet.</b></p>`,
          });
        }
      } else {
        toastError(res.msg);
      }
    });
  };

  const startLiveStream = (element) => {
    addLiveStreamAttendanceOfStudent(element, 'zoho', function () {
      if (isWebView) {
        window.location.href = element.meeting_link;
      } else if (isIosApp) {
        iosRedirect(element.meeting_link);
      } else {
        window.open(element.meeting_link, '_blank');
      }
      updateUsageTrack(clientId);
    });
  };

  const addLiveStreamAttendanceOfStudent = (element, st = null, cb) => {
    const payload = {
      client_user_id: clientUserId,
      stream_id: element.stream_id,
      stream_type: st || element.stream_type,
    };
    post(payload, '/addLiveStreamAttendanceOfStudent').then((res) => cb());
  };

  const goToRecording = (app) => {
    history.push({
      pathname: '/videoplayer',
      state: {
        videoLink: app.recording_url,
        videoId: app.zoho_meeting_recording_id,
        video_id: app.zoho_meeting_recording_id,
        file_name: app.appointment_title || 'Recorded Live Class',

        videoLinkArray: [],
      },
    });
  };

  return (
    <div className='appointment-card-upcoming mb-3'>
      <div className='card-top'>
        <div className='card-left'>
          <h3 className='card-title fontBold'>{appointment.appointment_title}</h3>
          <div className='info-row'>
            <svg className='icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
              <path
                strokeLinecap='round'
                strokeLinejoin='round'
                strokeWidth='2'
                d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
              />
            </svg>
            <span className='font'>
              {appointment.host_name}(Host), {appointment.student_name}
            </span>
          </div>
        </div>

        <div className='card-right'>
          <div className='time-section'>
            <div className='time-row'>
              <svg className='clock-icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
                />
              </svg>
              <span className='fontBold time-text'>
                {formatTime(appointment.start_time)} - {formatTime(appointment.end_time)} (
                {appointment.duration} mins)
              </span>
            </div>

            {appointment.appointment_date && isDash && (
              <div className='time-row'>
                <svg className='clock-icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'
                  />
                </svg>
                <span className=' time-text fontBold'>
                  {formatDate(appointment.appointment_date)}
                </span>
              </div>
            )}
          </div>

          <div className='action-buttons-card'>
            <button onClick={openDrawer} className='view-details-button font'>
              View details
            </button>

            {!isCompleted &&
              shouldShowJoinButton(appointment) &&
              (appointment.host_id === clientUserId ? (
                <button
                  onClick={() => startOrJoinClass(appointment)}
                  className='join-button font'
                  disabled={checkLiveClass}
                >
                  {checkLiveClass ? 'Starting...' : 'Start / Rejoin'}
                </button>
              ) : (
                <button
                  onClick={() => startOrJoinClass(appointment)}
                  className='join-button font'
                  disabled={checkLiveClass}
                >
                  {checkLiveClass ? 'Joining...' : 'Join'}
                </button>
              ))}
            {isCompleted && appointment.recording_url && (
              <button onClick={() => goToRecording(appointment)} className='join-button font'>
                View Recording
              </button>
            )}
          </div>
        </div>
      </div>
      <Drawer
        anchor='right'
        open={drawer}
        onClose={handleCloseDrawer}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: '500px', md: '600px' },
          },
        }}
      >
        <div className='appointment-drawer'>
          <div className='drawer-header'>
            <h2 className='drawer-title fontBold'>Appointment Details</h2>
            <button onClick={handleCloseDrawer} className='close-button'>
              <svg width='24' height='24' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth='2'
                  d='M6 18L18 6M6 6l12 12'
                />
              </svg>
            </button>
          </div>

          <div className='drawer-content'>
            <div className='detail-section'>
              <h3 className='section-title fontBold'>{appointment.appointment_title}</h3>
              <span className={`status-badge status-${appointment.appointment_status}`}>
                {appointment.appointment_status?.toUpperCase()}
              </span>
            </div>

            <div className='detail-section'>
              <h4 className='section-subtitle fontBold'>Date & Time</h4>
              <div className='detail-row'>
                <svg className='detail-icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z'
                  />
                </svg>
                <div className='detail-info'>
                  <span className='detail-label font'>Date</span>
                  <span className='detail-value fontBold'>
                    {formatDate(appointment.appointment_date)}
                  </span>
                </div>
              </div>
              <div className='detail-row'>
                <svg className='detail-icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
                <div className='detail-info'>
                  <span className='detail-label font'>Time</span>
                  <span className='detail-value fontBold'>
                    {formatTime(appointment.start_time)} - {formatTime(appointment.end_time)}
                  </span>
                </div>
              </div>
              <div className='detail-row'>
                <svg className='detail-icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
                <div className='detail-info'>
                  <span className='detail-label font'>Duration</span>
                  <span className='detail-value fontBold'>{appointment.duration} Minutes</span>
                </div>
              </div>
            </div>

            <div className='detail-section'>
              <h4 className='section-subtitle fontBold'>Participants</h4>
              <div className='detail-row'>
                <svg className='detail-icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
                  />
                </svg>
                <div className='detail-info'>
                  <span className='detail-label font'>Host</span>
                  <span className='detail-value fontBold'>{appointment.host_name}</span>
                </div>
              </div>
              <div className='detail-row'>
                <svg className='detail-icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z'
                  />
                </svg>
                <div className='detail-info'>
                  <span className='detail-label font'>Attendee</span>
                  <span className='detail-value fontBold'>{appointment.student_name}</span>
                </div>
              </div>
              <div className='detail-row'>
                <svg className='detail-icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z'
                  />
                </svg>
                <div className='detail-info'>
                  <span className='detail-label font'>Contact</span>
                  <span className='detail-value fontBold'>{appointment.student_contact}</span>
                </div>
              </div>
            </div>

            <div className='detail-section'>
              <h4 className='section-subtitle fontBold'>Location</h4>
              <div className='detail-row'>
                <svg className='detail-icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z'
                  />
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M15 11a3 3 0 11-6 0 3 3 0 016 0z'
                  />
                </svg>
                <div className='detail-info'>
                  <span className='detail-label font'>Address</span>
                  <span className='detail-value fontBold'>
                    {appointment.city}, {appointment.state}
                    <br />
                    {appointment.pincode}, {appointment.country}
                  </span>
                </div>
              </div>
            </div>

            <div className='detail-section'>
              <h4 className='section-subtitle fontBold'>Payment Information</h4>

              <div className='detail-row'>
                <svg className='detail-icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z'
                  />
                </svg>
                <div className='detail-info'>
                  <span className='detail-label font'>Amount</span>
                  <span className='detail-value fontBold'>₹{appointment.amount}</span>
                </div>
              </div>
              <div className='detail-row'>
                <svg className='detail-icon' fill='none' stroke='currentColor' viewBox='0 0 24 24'>
                  <path
                    strokeLinecap='round'
                    strokeLinejoin='round'
                    strokeWidth='2'
                    d='M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z'
                  />
                </svg>
                <div className='detail-info'>
                  <span className='detail-label font'>Invoice Number</span>
                  <span className='detail-value fontBold'>{appointment.invoice_number}</span>
                </div>
              </div>

              {appointment.paid_at && (
                <div className='detail-row'>
                  <svg
                    className='detail-icon'
                    fill='none'
                    stroke='currentColor'
                    viewBox='0 0 24 24'
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      strokeWidth='2'
                      d='M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z'
                    />
                  </svg>
                  <div className='detail-info'>
                    <span className='detail-label font'>Paid At</span>
                    <span className='detail-value fontBold'>
                      {new Date(parseInt(appointment.paid_at) * 1000).toLocaleString()}
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
};

export default AppointmentCard;
